'use client'
import { useQuery } from '@tanstack/react-query'
import type { UseQueryResult } from '@tanstack/react-query'
import { useParams } from 'next/navigation'
import {
  QUERY_AVAILABILITY_SEARCH,
  fetchAvailabilitySearch,
} from './fetchAvailabilitySearch'
import useAuthentication from '../useAuthentication'
import { RESERVATION_MODE_ENUM } from 'utils/constants'
import type { SearchResultModel } from 'core/bookings/types'

export interface UseQueryAvailabilitySearchParams {
  hotelCodes: string[]
  checkIn: string
  checkOut: string
  amenities: string
  numberRoomGuest: string
  type: string
  orderBy: string
  mode?: RESERVATION_MODE_ENUM
  roomPlanCodes?: string[] | null
  hotelPlanCodes?: string[] | null
  enabled?: boolean
  searchType?: 'undated'
  nights?: number
}

function useQueryAvailabilitySearch({
  hotelCodes,
  checkIn,
  checkOut,
  amenities,
  numberRoomGuest,
  type,
  orderBy,
  mode,
  roomPlanCodes,
  hotelPlanCodes,
  enabled,
  searchType,
  nights,
}: UseQueryAvailabilitySearchParams): UseQueryResult<
  SearchResultModel | null | undefined
> {
  const params = useParams<{ locale: string }>()
  const { locale } = params || {}
  const { withTriplaApiRequest } = useAuthentication()

  return useQuery({
    queryKey: [
      QUERY_AVAILABILITY_SEARCH,
      {
        mode,
        hotelCodes,
        amenities,
        numberRoomGuest,
        checkIn,
        checkOut,
        type,
        orderBy,
        roomPlanCodes,
        hotelPlanCodes: hotelPlanCodes?.filter((x: any) => x) || null,
        locale,
        searchType,
        nights,
      },
    ],
    queryFn: withTriplaApiRequest(fetchAvailabilitySearch),
    enabled,
  })
}

export default useQueryAvailabilitySearch
